<script>
import SkeletonScreen from '@/components/skeleton-screen'
const zeroSrc = require('@/static/images/zero.png')
export default {
  props: {
    tag: {
      type: String,
      default: 'ul'
    },
    list: {
      type: Array,
      default () {
        return []
      }
    },
    errorComp: {
      type: Object,
      default () {
        return SkeletonScreen
      }
    },
    loadingComp: {
      type: Object,
      default () {
        return SkeletonScreen
      }
    },
    currentComp: {
      type: Object,
      default () {
        return {}
      },
      required: true
    },
    delay: {
      type: Number,
      default: 0
    },
    timeout: {
      type: Number,
      default: 10000
    },
    loadding: {
      type: Boolean,
      default: true
    }
  },
  components: {
    SkeletonScreen
  },
  created () {
    //$options.components同名冲突问题
    this.$options.components[`list${this._uid}`] = () => {
      return {
        component: new Promise((resolve, reject) => {
          this.resolved = resolve
        }),
        loadding: this.loadingComp,
        error: this.errorComp,
        delay: this.delay,
        timeout: this.timeout
      }
    }
  },
  watch: {
    list: {
      immediate: true,
      handler (newVal) {
        if (newVal.length >= 1) {
          this.$nextTick(() => {
            this.resolved(this.currentComp)
          })
        }
      }
    }
  },
  render () {
    /*eslint-disable*/
    let childRender
    if (!this.loadding && !this.list.length) {
      childRender = [this._c({
        template: `<h1 class="iv-text-center iv-m-t-24">
                      <img :src="src" />
                    </h1>`,
        data () {
          return {
            src: zeroSrc
          }
        }
      })]
    } else if (this.loadding) {
      childRender = [this._c(SkeletonScreen)]
    } else {
      childRender = this._l(this.list, (item, $index) => {
        return this._c(`list${this._uid}`, {
          props: {
            item,
            index: $index,
            ...this.$attrs
          }
        })
      })
    }
    return this._c(this.tag, childRender)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/list/index.vue